import { injectable } from '@servicetitan/react-ioc';
import { action, observable, makeObservable } from 'mobx';

@injectable()
export class DelayedPopoverStore {
    @observable
    isOpen = false;

    private closeTimeOut!: number;
    private autoOpenDelayTimeout!: number;

    constructor() {
        makeObservable(this);
    }

    @action
    setIsOpen(isOpen: boolean) {
        this.isOpen = isOpen;
    }

    open() {
        window.clearTimeout(this.closeTimeOut);
        this.setIsOpen(true);
    }

    autoOpen(autoOpenTime = 5000, autoOpenDelay = 1500) {
        clearTimeout(this.autoOpenDelayTimeout);

        this.autoOpenDelayTimeout = window.setTimeout(() => {
            this.open();
            this.close(autoOpenTime);
        }, autoOpenDelay);
    }

    close(delay = 100) {
        clearTimeout(this.closeTimeOut);
        this.closeTimeOut = window.setTimeout(() => {
            this.setIsOpen(false);
        }, delay);
    }
}
